import BASE_RULE from '../baseRule';
import {KeywordType, SearchTypeKeyword} from './constants';
import {KeywordRule} from './types';

export const keywordRuleDefaults: KeywordRule = {
	...BASE_RULE,
	elementType: SearchTypeKeyword,
	elementSubType1: KeywordType.MATCH_ALL_FRAGMENTS,
};

export default keywordRuleDefaults;
